/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 网点管理-网点信息-展示配置
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import { Functions } from '@/library/utils/functions';

// 子组件
import SwiperCp from '@/views/components/pageConfigComponents/swiperCp/swiperCp.vue';
import SwiperEditCp from '@/views/components/pageConfigComponents/swiperEditCp/swiperEditCp.vue';
import ClassGoods from '@/views/components/pageConfigComponents/classGoods/classGoods.vue';
import ClassGoodsEdit from '@/views/components/pageConfigComponents/classGoodsEdit/classGoodsEdit.vue';

@Component({
  components: {
    SwiperCp,
    SwiperEditCp,
    ClassGoods,
    ClassGoodsEdit,
  },
})
export default class AppDisplayConfig extends Vue {
  /* 数据 */

  /**
   * 页面配置
   * @type {ItemObject}
   */
  public pageConfig: ItemObject = {
    Swiper: { desc: [] },
    Video: { desc: { url: '' } },
    ProductGroup: { desc: {} },
  };

  /**
   *  图片上传地址
   *  @type {string}
   */
  public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 页面显示类型
   * @type {string}
   */
  public showType = '1';

  /**
   * 选中的模块索引
   * @type {number}
   */
  public chooseIndex = 1;

  /* 方法 */

  /**
   * 返回列表
   * @return null
   */
  public toBack() {
    this.$router.go(-1);
  }

  /**
   * 获取页面配置信息
   * @return null
   */
  public getPageConfig(): void {
    const queryParams = {
      sgId: Number.parseInt(this.$route.params.id),
    };
    IPSService.getPageConfigInfo({ queryParams }).then((res) => {
      if (res.list.length > 0) {
        // 数组转对象
        for (const key in res.list) {
          this.pageConfig[res.list[key].filedType] = res.list[key];
        }
        if (this.pageConfig.hasOwnProperty('Video') && this.pageConfig.Video.desc.url) {
          this.pageConfig.Swiper = { desc: [] };
          this.showType = '2';
        } else {
          this.pageConfig.Video = { desc: { url: '' } };
          this.showType = '1';
        }
      }
    });
  }

  /**
   * 保存展示配置
   * @return null
   */
  public onSubmitDisplayConfig() {
    // 组装参数
    const temObj = JSON.parse(JSON.stringify(this.pageConfig));
    if (this.showType === '1') {
      delete temObj.Video;
    } else {
      if (!temObj.Video.desc.url) {
        this.$message.error('请输入合法的视频地址');
        return;
      }
      delete temObj.Swiper;
    }
    // 组装参数
    const tempList = [];
    for (const item in temObj) {
      temObj[item].filedType = item;
      tempList.push(temObj[item]);
    }
    const postParams = {
      sgId: Number.parseInt(this.$route.params.id),
      list: tempList,
    };
    IPSService.updatePageConfig({ postParams }).then((res) => {
      if (res) { this.$message.success('保存成功'); }
    });
  }

  /**
   * 图片上传之前的格式验证
   * @param file
   * @returns {boolean}
   */
  beforeAvatarUpload(file) {
    console.debug(file);
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isGIF = file.type === 'image/gif';
    const isLt500KB = file.size / 1024 < 500;
    if (!isJPG && !isPNG && !isGIF) {
      this.$message.error('上传图片只支持 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!isLt500KB) {
      this.$message.error('上传图片大小不能超过 500KB!');
    }
    return (isJPG || isPNG || isGIF) && isLt500KB;
  }

  /**
   * 图片上传成功时的处理
   * @param res
   * @param file
   */
  handleAvatarSuccess(res: HttpAPIRetItem<any>, file: any) {
    this.pageConfig.BackPicture.desc.url = res.content;
  }

  /**
   * 上传失败提示
   * @param err
   */
  uploadError(err) {
    const result = JSON.parse(err.message);
    if (result.message) {
      this.$message.error(result.message);
    }
  }

  /**
   * 改变选中的模块索引
   * @param index
   */
  public onChangechooseIndex(index): void {
    this.chooseIndex = index;
  }
  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getPageConfig(); // 获取页面配置信息
  }
}
